// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  font-family: Calibri;
}

.reportPageCont {
  background: var(--color-blue-5-light);
  display: block;
  height: 100%;
  width: 100%;
  padding: 20px;
}

.reportPage {
  height: 100%;
  width: 100%;
  background: var(--color-white-light);
  border-radius: 10px;
  padding: 10px 0px;
  overflow: hidden;
}

.reportPage h1 {
  font-size: 22px;
  font-weight: 600;
  color: var(--color-blue-3-light);
  text-transform: uppercase;
  font-family: Calibri;
  margin: 0 0 5px 0;
}

.report_row {
  padding: 10px 0;
  border: solid 1px var(--color-gray-12-light);
  border-bottom-style: solid;
  font-size: 14px;
  color: var(--color-gray-4-light);
  font-family: Calibri;
}

.prfilePic {
  height: 145px;
  width: 145px;
  border-radius: 100%;
  overflow: hidden;
  margin: auto;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.prfilePic img {
  height: 100%;
  width: 100%;
}

.profileDetails ul {
  list-style: none;
  font-weight: 600;
  padding: 0;
  font-size: 16px;
  color: var(--color-blue-1-light);
}
.profileDetails ul li {
  margin-bottom: 4px;
}
.profileDetails ul li span {
  color: var(--color-gray-9-light);
  font-weight: 400;
}
.profileDetails ul li:nth-child(1) {
  padding-top: 10px;
}
.profileDetails ul li:nth-last-child(1) {
  margin-bottom: 40px;
}

.about h2 {
  font-size: 22px;
  font-weight: 600;
}
.about h6 {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-blue-3-light);
}
.about p {
  color: var(--color-gray-9-light);
}
.about p span {
  color: var(--color-black-light);
}

.manageWedige {
  width: 100%;
  height: 300px;
  padding-top: 10px;
  overflow: hidden;
  border-radius: 12px;
  border: 4px double var(--color-gray-12-light);
}
.manageWedige h3 {
  border-bottom: 1px solid var(--color-blue-1-light);
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 600;
  padding: 0px 0px 5px 5px;
}
.manageWedige .widget {
  overflow-y: scroll;
  height: 90%;
  width: 96%;
}

.hed {
  border-top: solid 2px var(--color-blue-3-light);
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 600;
  padding: 5px 0px 0px 5px;
}

.left-line::after {
  height: 100%;
  width: 1px;
  background: var(--color-blue-0-light);
  position: absolute;
  content: "";
  top: 0;
  left: 0;
}

.left {
  padding: 0px 20px;
}

.right {
  padding: 0px 20px;
}

.norml-size {
  display: block;
}

.small-size {
  display: none;
}
.small-size .about p {
  margin: 0;
}
.small-size .about h6 {
  margin: 0;
  font-size: 14px;
}
.small-size .profileCover {
  width: 120px;
  height: 120px;
  border-radius: 100%;
  overflow: hidden;
  margin: auto;
}
.small-size .profileCover img {
  width: 100%;
  height: 100%;
}
.small-size ul {
  list-style: none;
  font-weight: 600;
  padding: 0;
  font-size: 16px;
  color: var(--color-blue-1-light);
}
.small-size ul li {
  margin-bottom: 4px;
}
.small-size ul li span {
  color: var(--color-gray-9-light);
  font-weight: 400;
}
.small-size ul li:nth-child(1) {
  padding-top: 10px;
}
.small-size ul li:nth-last-child(1) {
  margin-bottom: 40px;
}

@media only screen and (max-device-width: 425px) {
  .small-size .right {
    padding: 0px 10px;
  }
  .small-size ul {
    font-size: 18px;
    margin: 0;
    text-align: center;
  }
  .small-size ul li {
    font-size: 14px;
  }
  .small-size ul li:nth-last-child(1) {
    margin-bottom: 0px;
  }
  .small-size .about h2 {
    font-size: 15px;
    margin-top: 30px;
  }
  .small-size .about h6 {
    font-size: 12px;
  }
  .small-size .about p {
    font-size: 12px;
  }
}
@media only screen and (max-device-height: 600px) {
  .manageWedige {
    height: 230px;
  }
}
@media only screen and (max-device-height: 530px) {
  .manageWedige {
    height: 150px;
  }
}
@media only screen and (max-device-width: 768px) and (device-height: 570px) {
  .manageWedige {
    height: 244px;
  }
}
@media only screen and (max-device-width: 425px) {
  .norml-size {
    display: none !important;
  }
  .small-size {
    display: block !important;
  }
  .small-size .manageWedige {
    height: 230px;
  }
}
ion-content.dark {
  color: var(--color-black-dark);
}

.dark .reportPageCont {
  background: var(--color-blue-5-dark);
}
.dark .reportPage {
  background: var(--color-white-dark);
}
.dark .reportPage h1 {
  color: var(--color-blue-3-dark);
}
.dark .report_row {
  color: var(--color-gray-4-dark);
  border: solid 1px var(--color-gray-12-dark);
}
.dark .profileDetails ul {
  color: var(--color-blue-1-light);
}
.dark .profileDetails ul li {
  color: var(--color-black-dark);
}
.dark .profileDetails ul li span {
  color: var(--color-black-dark);
}
.dark .about h2, .dark .about h3 {
  color: var(--color-black-dark);
}
.dark .about h6 {
  color: var(--color-blue-3-dark);
}
.dark .about p {
  color: var(--color-black-dark);
}
.dark .about p span {
  color: var(--color-black-dark);
}
.dark .manageWedige {
  border: 4px double var(--color-gray-12-dark);
}
.dark .manageWedige h3 {
  border-bottom: 1px solid var(--color-blue-1-dark);
}
.dark .hed {
  border-top: 2px solid var(--color-blue-3-dark);
}
.dark .left-line::after {
  background: var(--color-blue-0-dark);
}
.dark .small-size ul {
  color: var(--color-blue-1-dark);
}
.dark .small-size ul li span {
  color: var(--color-gray-9-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/containers/settings/settings.page.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/containers/settings/settings.page.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;ACCJ;;ADEA;EACI,qCAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;ACCJ;;ADEA;EACI,YAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;ACCJ;;ADEA;EACI,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;ACCJ;;ADEA;EACI,eAAA;EACA,4CAAA;EACA,0BAAA;EACA,eAAA;EACA,gCAAA;EACA,oBAAA;ACCJ;;ADEA;EAGI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;ACDJ;ADGI;EACI,YAAA;EACA,WAAA;ACDR;;ADMI;EACI,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gCAAA;ACHR;ADKQ;EACI,kBAAA;ACHZ;ADKY;EACI,gCAAA;EACA,gBAAA;ACHhB;ADOQ;EACI,iBAAA;ACLZ;ADQQ;EACI,mBAAA;ACNZ;;ADYI;EACI,eAAA;EACA,gBAAA;ACTR;ADaI;EACI,eAAA;EACA,gBAAA;EACA,gCAAA;ACXR;ADcI;EACI,gCAAA;ACZR;ADcQ;EACI,+BAAA;ACZZ;;ADiBA;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;ACdJ;ADgBI;EACI,kDAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;ACdR;ADiBI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;ACfR;;ADoBA;EACI,+CAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;ACjBJ;;ADoBA;EACI,YAAA;EACA,UAAA;EACA,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;ACjBJ;;ADqBA;EACI,iBAAA;AClBJ;;ADqBA;EACI,iBAAA;AClBJ;;ADqBA;EACI,cAAA;AClBJ;;ADqBA;EACI,aAAA;AClBJ;ADqBQ;EACI,SAAA;ACnBZ;ADuBQ;EACI,SAAA;EACA,eAAA;ACrBZ;ADyBI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;ACvBR;ADyBQ;EACI,WAAA;EACA,YAAA;ACvBZ;AD2BI;EACI,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gCAAA;ACzBR;AD2BQ;EACI,kBAAA;ACzBZ;AD2BY;EACI,gCAAA;EACA,gBAAA;ACzBhB;AD6BQ;EACI,iBAAA;AC3BZ;AD8BQ;EACI,mBAAA;AC5BZ;;ADiCA;EAEQ;IACI,iBAAA;EC/BV;EDkCM;IACI,eAAA;IACA,SAAA;IACA,kBAAA;EChCV;EDkCU;IACI,eAAA;EChCd;EDmCU;IACI,kBAAA;ECjCd;EDsCU;IACI,eAAA;IACA,gBAAA;ECpCd;EDuCU;IACI,eAAA;ECrCd;EDwCU;IACI,eAAA;ECtCd;AACF;AD2CA;EACI;IACI,aAAA;ECzCN;AACF;AD4CA;EACI;IACI,aAAA;EC1CN;AACF;AD6CA;EACI;IACI,aAAA;EC3CN;AACF;AD8CA;EACI;IACI,wBAAA;EC5CN;ED+CE;IACI,yBAAA;EC7CN;ED+CM;IACI,aAAA;EC7CV;AACF;ADiDA;EACI,8BAAA;AC/CJ;;ADmDI;EACI,oCAAA;AChDR;ADmDI;EACI,mCAAA;ACjDR;ADoDI;EACI,+BAAA;AClDR;ADqDI;EACI,+BAAA;EACA,2CAAA;ACnDR;ADuDQ;EACI,gCAAA;ACrDZ;ADuDY;EACI,8BAAA;ACrDhB;ADsDgB;EACI,8BAAA;ACpDpB;AD2DQ;EACI,8BAAA;ACzDZ;AD4DQ;EACI,+BAAA;AC1DZ;AD6DQ;EACI,8BAAA;AC3DZ;AD6DY;EACI,8BAAA;AC3DhB;ADgEI;EACI,4CAAA;AC9DR;ADgEQ;EACI,iDAAA;AC9DZ;ADkEI;EACI,8CAAA;AChER;ADmEI;EACI,oCAAA;ACjER;ADqEQ;EACI,+BAAA;ACnEZ;ADsEgB;EACI,+BAAA;ACpEpB","sourcesContent":["ion-content {\r\n    font-family: Calibri;\r\n}\r\n\r\n.reportPageCont {\r\n    background: var(--color-blue-5-light);\r\n    display: block;\r\n    height: 100%;\r\n    width: 100%;\r\n    padding: 20px;\r\n}\r\n\r\n.reportPage {\r\n    height: 100%;\r\n    width: 100%;\r\n    background: var(--color-white-light);\r\n    border-radius: 10px;\r\n    padding: 10px 0px; // 15px 80px 0px 80px;\r\n    overflow: hidden;\r\n}\r\n\r\n.reportPage h1 {\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n    color: var(--color-blue-3-light);\r\n    text-transform: uppercase;\r\n    font-family: Calibri;\r\n    margin: 0 0 5px 0;\r\n}\r\n\r\n.report_row {\r\n    padding: 10px 0;\r\n    border: solid 1px var(--color-gray-12-light);\r\n    border-bottom-style: solid;\r\n    font-size: 14px;\r\n    color: var(--color-gray-4-light);\r\n    font-family: Calibri;\r\n}\r\n\r\n.prfilePic {\r\n    // height: 214px;\r\n    // width: 214px;\r\n    height: 145px;\r\n    width: 145px;\r\n    border-radius: 100%;\r\n    overflow: hidden;\r\n    margin: auto;\r\n    background-size: 100% 100%;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n\r\n    img {\r\n        height: 100%;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.profileDetails {\r\n    ul {\r\n        list-style: none;\r\n        font-weight: 600;\r\n        padding: 0;\r\n        font-size: 16px;\r\n        color: var(--color-blue-1-light);\r\n\r\n        li {\r\n            margin-bottom: 4px;\r\n\r\n            span {\r\n                color: var(--color-gray-9-light);\r\n                font-weight: 400;\r\n            }\r\n        }\r\n\r\n        li:nth-child(1) {\r\n            padding-top: 10px;\r\n        }\r\n\r\n        li:nth-last-child(1) {\r\n            margin-bottom: 40px;\r\n        }\r\n    }\r\n}\r\n\r\n.about {\r\n    h2 {\r\n        font-size: 22px;\r\n        font-weight: 600;\r\n\r\n    }\r\n\r\n    h6 {\r\n        font-size: 18px;\r\n        font-weight: 600;\r\n        color: var(--color-blue-3-light);\r\n    }\r\n\r\n    p {\r\n        color: var(--color-gray-9-light);\r\n\r\n        span {\r\n            color: var(--color-black-light);\r\n        }\r\n    }\r\n}\r\n\r\n.manageWedige {\r\n    width: 100%;\r\n    height: 300px;\r\n    padding-top: 10px;\r\n    overflow: hidden;\r\n    border-radius: 12px;\r\n    border: 4px double var(--color-gray-12-light);\r\n\r\n    h3 {\r\n        border-bottom: 1px solid var(--color-blue-1-light);\r\n        font-size: 20px;\r\n        margin-bottom: 20px;\r\n        font-weight: 600;\r\n        padding: 0px 0px 5px 5px;\r\n    }\r\n\r\n    .widget {\r\n        overflow-y: scroll;\r\n        height: 90%;\r\n        width: 96%;\r\n    }\r\n\r\n}\r\n\r\n.hed {\r\n    border-top: solid 2px var(--color-blue-3-light);\r\n    font-size: 20px;\r\n    margin-bottom: 20px;\r\n    font-weight: 600;\r\n    padding: 5px 0px 0px 5px;\r\n}\r\n\r\n.left-line::after {\r\n    height: 100%;\r\n    width: 1px;\r\n    background: var(--color-blue-0-light);\r\n    position: absolute;\r\n    content: \"\";\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n\r\n.left {\r\n    padding: 0px 20px;\r\n}\r\n\r\n.right {\r\n    padding: 0px 20px;\r\n}\r\n\r\n.norml-size {\r\n    display: block;\r\n}\r\n\r\n.small-size {\r\n    display: none;\r\n\r\n    .about {\r\n        p {\r\n            margin: 0;\r\n\r\n        }\r\n\r\n        h6 {\r\n            margin: 0;\r\n            font-size: 14px;\r\n        }\r\n    }\r\n\r\n    .profileCover {\r\n        width: 120px;\r\n        height: 120px;\r\n        border-radius: 100%;\r\n        overflow: hidden;\r\n        margin: auto;\r\n\r\n        img {\r\n            width: 100%;\r\n            height: 100%;\r\n        }\r\n    }\r\n\r\n    ul {\r\n        list-style: none;\r\n        font-weight: 600;\r\n        padding: 0;\r\n        font-size: 16px;\r\n        color: var(--color-blue-1-light);\r\n\r\n        li {\r\n            margin-bottom: 4px;\r\n\r\n            span {\r\n                color: var(--color-gray-9-light);\r\n                font-weight: 400;\r\n            }\r\n        }\r\n\r\n        li:nth-child(1) {\r\n            padding-top: 10px;\r\n        }\r\n\r\n        li:nth-last-child(1) {\r\n            margin-bottom: 40px;\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (max-device-width: 425px) {\r\n    .small-size {\r\n        .right {\r\n            padding: 0px 10px;\r\n        }\r\n\r\n        ul {\r\n            font-size: 18px;\r\n            margin: 0;\r\n            text-align: center;\r\n\r\n            li {\r\n                font-size: 14px;\r\n            }\r\n\r\n            li:nth-last-child(1) {\r\n                margin-bottom: 0px;\r\n            }\r\n        }\r\n\r\n        .about {\r\n            h2 {\r\n                font-size: 15px;\r\n                margin-top: 30px\r\n            }\r\n\r\n            h6 {\r\n                font-size: 12px;\r\n            }\r\n\r\n            p {\r\n                font-size: 12px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (max-device-height: 600px) {\r\n    .manageWedige {\r\n        height: 230px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-device-height: 530px) {\r\n    .manageWedige {\r\n        height: 150px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-device-width: 768px) and (device-height: 570px) {\r\n    .manageWedige {\r\n        height: 244px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-device-width: 425px) {\r\n    .norml-size {\r\n        display: none !important;\r\n    }\r\n\r\n    .small-size {\r\n        display: block !important;\r\n\r\n        .manageWedige {\r\n            height: 230px;\r\n        }\r\n    }\r\n}\r\n\r\nion-content.dark {\r\n    color: var(--color-black-dark);\r\n}\r\n\r\n.dark {   \r\n    .reportPageCont {\r\n        background: var(--color-blue-5-dark);\r\n    }\r\n    \r\n    .reportPage {\r\n        background: var(--color-white-dark);\r\n    }\r\n    \r\n    .reportPage h1 {\r\n        color: var(--color-blue-3-dark);\r\n    }\r\n    \r\n    .report_row {\r\n        color: var(--color-gray-4-dark);\r\n        border: solid 1px var(--color-gray-12-dark);\r\n    }\r\n    \r\n    .profileDetails {\r\n        ul {\r\n            color: var(--color-blue-1-light);\r\n\r\n            li {\r\n                color: var(--color-black-dark);\r\n                span {\r\n                    color: var(--color-black-dark);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n    .about {\r\n        h2, h3 {\r\n            color: var(--color-black-dark);\r\n        }\r\n\r\n        h6 {\r\n            color: var(--color-blue-3-dark);\r\n        }\r\n    \r\n        p {\r\n            color: var(--color-black-dark);\r\n    \r\n            span {\r\n                color: var(--color-black-dark);\r\n            }\r\n        }\r\n    }\r\n    \r\n    .manageWedige {\r\n        border: 4px double var(--color-gray-12-dark);\r\n    \r\n        h3 {\r\n            border-bottom: 1px solid var(--color-blue-1-dark);\r\n        }\r\n    }\r\n    \r\n    .hed {\r\n        border-top: 2px solid var(--color-blue-3-dark);\r\n    }\r\n    \r\n    .left-line::after {\r\n        background: var(--color-blue-0-dark);\r\n    }\r\n    \r\n    .small-size {      \r\n        ul {\r\n            color: var(--color-blue-1-dark);\r\n    \r\n            li {\r\n                span {\r\n                    color: var(--color-gray-9-dark);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","ion-content {\n  font-family: Calibri;\n}\n\n.reportPageCont {\n  background: var(--color-blue-5-light);\n  display: block;\n  height: 100%;\n  width: 100%;\n  padding: 20px;\n}\n\n.reportPage {\n  height: 100%;\n  width: 100%;\n  background: var(--color-white-light);\n  border-radius: 10px;\n  padding: 10px 0px;\n  overflow: hidden;\n}\n\n.reportPage h1 {\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--color-blue-3-light);\n  text-transform: uppercase;\n  font-family: Calibri;\n  margin: 0 0 5px 0;\n}\n\n.report_row {\n  padding: 10px 0;\n  border: solid 1px var(--color-gray-12-light);\n  border-bottom-style: solid;\n  font-size: 14px;\n  color: var(--color-gray-4-light);\n  font-family: Calibri;\n}\n\n.prfilePic {\n  height: 145px;\n  width: 145px;\n  border-radius: 100%;\n  overflow: hidden;\n  margin: auto;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.prfilePic img {\n  height: 100%;\n  width: 100%;\n}\n\n.profileDetails ul {\n  list-style: none;\n  font-weight: 600;\n  padding: 0;\n  font-size: 16px;\n  color: var(--color-blue-1-light);\n}\n.profileDetails ul li {\n  margin-bottom: 4px;\n}\n.profileDetails ul li span {\n  color: var(--color-gray-9-light);\n  font-weight: 400;\n}\n.profileDetails ul li:nth-child(1) {\n  padding-top: 10px;\n}\n.profileDetails ul li:nth-last-child(1) {\n  margin-bottom: 40px;\n}\n\n.about h2 {\n  font-size: 22px;\n  font-weight: 600;\n}\n.about h6 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-blue-3-light);\n}\n.about p {\n  color: var(--color-gray-9-light);\n}\n.about p span {\n  color: var(--color-black-light);\n}\n\n.manageWedige {\n  width: 100%;\n  height: 300px;\n  padding-top: 10px;\n  overflow: hidden;\n  border-radius: 12px;\n  border: 4px double var(--color-gray-12-light);\n}\n.manageWedige h3 {\n  border-bottom: 1px solid var(--color-blue-1-light);\n  font-size: 20px;\n  margin-bottom: 20px;\n  font-weight: 600;\n  padding: 0px 0px 5px 5px;\n}\n.manageWedige .widget {\n  overflow-y: scroll;\n  height: 90%;\n  width: 96%;\n}\n\n.hed {\n  border-top: solid 2px var(--color-blue-3-light);\n  font-size: 20px;\n  margin-bottom: 20px;\n  font-weight: 600;\n  padding: 5px 0px 0px 5px;\n}\n\n.left-line::after {\n  height: 100%;\n  width: 1px;\n  background: var(--color-blue-0-light);\n  position: absolute;\n  content: \"\";\n  top: 0;\n  left: 0;\n}\n\n.left {\n  padding: 0px 20px;\n}\n\n.right {\n  padding: 0px 20px;\n}\n\n.norml-size {\n  display: block;\n}\n\n.small-size {\n  display: none;\n}\n.small-size .about p {\n  margin: 0;\n}\n.small-size .about h6 {\n  margin: 0;\n  font-size: 14px;\n}\n.small-size .profileCover {\n  width: 120px;\n  height: 120px;\n  border-radius: 100%;\n  overflow: hidden;\n  margin: auto;\n}\n.small-size .profileCover img {\n  width: 100%;\n  height: 100%;\n}\n.small-size ul {\n  list-style: none;\n  font-weight: 600;\n  padding: 0;\n  font-size: 16px;\n  color: var(--color-blue-1-light);\n}\n.small-size ul li {\n  margin-bottom: 4px;\n}\n.small-size ul li span {\n  color: var(--color-gray-9-light);\n  font-weight: 400;\n}\n.small-size ul li:nth-child(1) {\n  padding-top: 10px;\n}\n.small-size ul li:nth-last-child(1) {\n  margin-bottom: 40px;\n}\n\n@media only screen and (max-device-width: 425px) {\n  .small-size .right {\n    padding: 0px 10px;\n  }\n  .small-size ul {\n    font-size: 18px;\n    margin: 0;\n    text-align: center;\n  }\n  .small-size ul li {\n    font-size: 14px;\n  }\n  .small-size ul li:nth-last-child(1) {\n    margin-bottom: 0px;\n  }\n  .small-size .about h2 {\n    font-size: 15px;\n    margin-top: 30px;\n  }\n  .small-size .about h6 {\n    font-size: 12px;\n  }\n  .small-size .about p {\n    font-size: 12px;\n  }\n}\n@media only screen and (max-device-height: 600px) {\n  .manageWedige {\n    height: 230px;\n  }\n}\n@media only screen and (max-device-height: 530px) {\n  .manageWedige {\n    height: 150px;\n  }\n}\n@media only screen and (max-device-width: 768px) and (device-height: 570px) {\n  .manageWedige {\n    height: 244px;\n  }\n}\n@media only screen and (max-device-width: 425px) {\n  .norml-size {\n    display: none !important;\n  }\n  .small-size {\n    display: block !important;\n  }\n  .small-size .manageWedige {\n    height: 230px;\n  }\n}\nion-content.dark {\n  color: var(--color-black-dark);\n}\n\n.dark .reportPageCont {\n  background: var(--color-blue-5-dark);\n}\n.dark .reportPage {\n  background: var(--color-white-dark);\n}\n.dark .reportPage h1 {\n  color: var(--color-blue-3-dark);\n}\n.dark .report_row {\n  color: var(--color-gray-4-dark);\n  border: solid 1px var(--color-gray-12-dark);\n}\n.dark .profileDetails ul {\n  color: var(--color-blue-1-light);\n}\n.dark .profileDetails ul li {\n  color: var(--color-black-dark);\n}\n.dark .profileDetails ul li span {\n  color: var(--color-black-dark);\n}\n.dark .about h2, .dark .about h3 {\n  color: var(--color-black-dark);\n}\n.dark .about h6 {\n  color: var(--color-blue-3-dark);\n}\n.dark .about p {\n  color: var(--color-black-dark);\n}\n.dark .about p span {\n  color: var(--color-black-dark);\n}\n.dark .manageWedige {\n  border: 4px double var(--color-gray-12-dark);\n}\n.dark .manageWedige h3 {\n  border-bottom: 1px solid var(--color-blue-1-dark);\n}\n.dark .hed {\n  border-top: 2px solid var(--color-blue-3-dark);\n}\n.dark .left-line::after {\n  background: var(--color-blue-0-dark);\n}\n.dark .small-size ul {\n  color: var(--color-blue-1-dark);\n}\n.dark .small-size ul li span {\n  color: var(--color-gray-9-dark);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
